import React from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import "./pnaStyle.css";

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
`;

export default function SubscriptionServicesAgreement(props) {
  return (
    <PageWrapper>
      <p className="c2">
        <span className="c1">
          This Subscription Services Agreement (the &ldquo;Agreement&rdquo;) is between
          LoanBoss, Inc., a North Carolina corporation (&ldquo;LoanBoss&rdquo;), and you and/or your employer
          (collectively &ldquo;Client,&rdquo; &ldquo;You,&rdquo; and/or &ldquo;Your&rdquo;) as set forth on the
          applicable services order form (each an &ldquo;Order&rdquo;).
        </span>
      </p>
      <h4 className="c5" id="h.ni23f98hppi6">
        <span className="c8">
          PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING THE
          SERVICES.
        </span>
      </h4>
      <p className="c2">
        <span className="c9 c11 c12">
          BY USING THE SERVICES AND/OR CLICKING &ldquo;AGREE&rdquo;, YOU ARE AGREEING
          TO BE BOUND BY THIS AGREEMENT. IF YOU ARE AGREEING TO THIS AGREEMENT ON BEHALF OF OR FOR THE BENEFIT OF YOUR
          EMPLOYER, THEN YOU REPRESENT AND WARRANT THAT YOU HAVE THE NECESSARY AUTHORITY TO AGREE TO THIS AGREEMENT ON
          YOUR EMPLOYER&rsquo;S BEHALF AND TO BIND YOUR EMPLOYER TO THIS AGREEMENT.
        </span>
      </p>
      <h4 className="c5" id="h.hz93kyi1i31n"><span className="c4">1. Description of Services</span></h4>
      <p className="c2">
        <span className="c1">
          LoanBoss shall grant to Client access to the services (each, a &ldquo;Service&rdquo;)
          set forth in the applicable Order.
        </span>
      </p>
      <h4 className="c5" id="h.qf4q8ad9j89h"><span className="c4">2. License Grant</span></h4>
      <p className="c2">
        <span className="c3">
          a. Limited License. Subject to Client&rsquo;s compliance with the terms and
          conditions of this Agreement, including, but not limited to, Client&rsquo;s obligation to pay the Fees (as
          defined in
          {" "}
        </span>
        <span className="c6 c3">Section 3</span>
        <span className="c3">
          ) when due, LoanBoss grants to Client
          a limited, non-exclusive, non-transferable license to access and use the Services during the Subscription
          Term (as defined in
          {" "}
        </span>
        <span className="c6 c3">Section 7</span>
        <span className="c1">
          ) of the applicable Order
          for Client&rsquo;s internal business purposes.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. Authorized Users. Client may permit, as applicable, its employees, contractors,
          and/or brokers to access and use the Services licensed by Client for the benefit of Client (collectively,
          &ldquo;Users&rdquo;). Use of the Services by Users shall be subject to any additional restrictions and/ or
          fees as set forth in the Order as well as notices and limits on functionalities as may be provided within
          the Services. Subject to the foregoing, with respect to permitted Users, Client shall act as the
          administrator of its account, and shall determine the level of access to the Services and the Client Content
          (as defined below) it grants to each such User. At all times, Client shall be responsible and liable for all
          actions of its Users. Client (i) must keep its and all User passwords secure and confidential; (ii) must use
          commercially reasonable efforts to prevent unauthorized access to its and its User&rsquo;s account and
          notify LoanBoss promptly of any such unauthorized access; (iii) must use the Services only in accordance
          with this Agreement and applicable law; and (iv) must provide true and accurate information in the course of
          creating user accounts.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          c. Restrictions on Use. Client shall not and shall ensure that each User does not (i)
          sell, resell, license, rent or lease the Services or use it in a service provider capacity; (ii) use the
          Services to store or transmit unsolicited marketing emails, libelous or otherwise objectionable, unlawful or
          tortious material, or to store or transmit material in violation of third party rights; (iii) interfere with
          or disrupt the integrity or performance of the Services; (iv) attempt to gain unauthorized access to the
          Services or its related systems or networks; (v) except as may be permitted by law, reverse engineer,
          decompile, disassemble, or otherwise attempt to discern the source code or interface protocols of the
          Services; (vi) access the Services to build a competitive service or product, or copy any feature, function
          or graphic for competitive purposes; (vii) utilize the Services in a manner that exceeds the license
          parameters provided on the relevant Order; (viii) use the Services in violation of any Applicable Law (as
          defined below) or for any purpose not specifically permitted in this Agreement; (ix) introduce, post, or
          upload to the LoanBoss platform any Harmful Code (as defined below); or (x) make available, communicate to
          the public by telecommunication, transmit under any law, contractual obligation (i.e., nondisclosure
          agreement), or fiduciary duty, any information about or related to the Services; or attempt yourself or
          permit or encourage any third party to do any of the above . As used in this Agreement, (1)
          &ldquo;Applicable Law&rdquo; means, with respect to any entity or person, any federal, state, or local
          statute, law, ordinance, rule, administrative interpretation, regulation, order, writ, injunction,
          directive, judgment, decree, or other requirement of any international, federal, state, or local court,
          administrative agency, or commission or other governmental or regulatory authority or instrumentality,
          domestic or foreign, applicable to such entity or person, or any of its properties, assets, or business
          operations, and (2) &ldquo;Harmful Code&rdquo; means computer code, programs, or programming devices that
          are intentionally designed to disrupt, modify, access, delete, damage, deactivate, disable, harm, or
          otherwise impede in any manner, including aesthetic disruptions or distortions, the operation of the
          LoanBoss platform or the LoanBoss website, or any other associated software, firmware, hardware, computer
          system, or network (including, without limitation, &ldquo;Trojan horses,&rdquo; &ldquo;viruses,&rdquo;
          &ldquo;worms,&rdquo; &ldquo;time bombs,&rdquo; &ldquo;time locks,&rdquo; &ldquo;devices,&rdquo;
          &ldquo;traps,&rdquo; &ldquo;access codes,&rdquo; or &ldquo;drop dead&rdquo; or &ldquo;trap door&rdquo;
          devices) or any other harmful, malicious, or hidden procedures, routines or mechanisms that would cause the
          Services to cease functioning or to damage or corrupt data, storage media, programs, equipment, or
          communications, or otherwise interfere with the operations of the Services.
        </span>
      </p>
      <h4 className="c5" id="h.qag75d3rh1d"><span className="c4">3. Payment</span></h4>
      <p className="c2">
        <span className="c1">
          a. Fees. In consideration for Client&rsquo;s access to and use of the Services,
          Client shall pay to LoanBoss the fees set forth in the applicable Order (the &ldquo;Fees&rdquo;). Client
          understands and agrees that for each renewal of the Subscription Term, the effective prices of the Services
          may be increased by LoanBoss by up to 10% above the applicable pricing for the same Services during the
          immediately preceding Subscription Term upon forty-five (45) days prior notice to Client.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. Taxes. All Fees are in addition to, and do not include, any federal, state, or
          local sales, use, withholding, VAT and other similar taxes (collectively, &ldquo;Taxes&rdquo;). Client is
          responsible for the payment of all applicable Taxes, without deduction or offset to the Fees due. Any
          applicable direct pay permits or valid tax-exempt certificates must be provided to LoanBoss prior to the
          execution of any Order. If LoanBoss is required to collect and remit Taxes on Client&rsquo;s behalf,
          LoanBoss will invoice Client for such Taxes, and Client will pay LoanBoss for such amounts in accordance
          with the payment terms set forth below.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          c. Payment Terms. Client will be invoiced for the Fees annually in advance, unless
          otherwise specified on the Order. Client must make payment under all invoices as specified on the Order, but
          if not specified, then within thirty (30) days of the date of an invoice.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          d. Expenses. Client shall be responsible for the cost of LoanBoss&rsquo;s reasonable
          and pre-approved travel and reasonable expenses associated with any onsite trainings and/or implementation
          services as may be set forth in the applicable Order.
        </span>
      </p>
      <h4 className="c5" id="h.5h1bl9h06q41"><span className="c4">4. Proprietary Rights</span></h4>
      <p className="c2">
        <span className="c1">
          a. Client Content. All data and content uploaded or transmitted by Client through the
          Services into its account or created or generated by Client within its account in the Services
          (collectively, &ldquo;Client Content&rdquo;) is and shall remain the property of Client, as between LoanBoss
          and Client. If Client is given permission by another customer of LoanBoss to access such other
          customer&rsquo;s account within the Service, then, as between Client and such other customer, the other
          customer shall remain the owner and data controller of any data uploaded or manipulated within such other
          customer&rsquo;s account. For the avoidance of doubt, Client Content expressly excludes any data and content
          accessed by Client which belongs to LoanBoss or another LoanBoss customer.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          LoanBoss will implement appropriate technical and organizational measures for
          protection of the security, confidentiality and integrity of Client Content, including any Client Personal
          Data (as defined in
          {" "}
        </span>
        <span className="c6 c3">Section 10</span>
        <span className="c1">
          &nbsp;herein). Subject to
          the terms and conditions of this Agreement, Client hereby grants LoanBoss a non-exclusive, worldwide, fully
          paid-up, royalty-free, transferable right and license, with the right to grant sublicenses to vendors
          providing services to LoanBoss related to the performance of the Services (such as hosting providers), to
          reproduce, execute, use, store, archive, modify, perform, display, and distribute the Client Content for the
          purpose of providing the Services hereunder, and for the purpose of creating Aggregate Data (as defined
          below). LoanBoss shall not be responsible for modifications, manipulations, updates or deletions to the
          Client Content made by Users nor responsible for confirming the accuracy of any Client Content. During the
          term of this Agreement, Client may export its Client Content as allowed by the functionality within the
          Service. Upon expiration or termination of the Agreement, LoanBoss may retain an archival copy of the Client
          Content kept in the normal course of business or for purposes of complying with Applicable Law.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. Third Party Software. Any third party software provided by LoanBoss as part of the
          Services and specified in an Order (&ldquo;Third Party Software&rdquo;) is licensed to Client as follows:
          LoanBoss grants Client a non-exclusive, non-transferable license, during the term of the Order, to
          internally operate and copy such Third Party Software, solely in connection with self-service reporting
          related to the Service.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          c. LoanBoss Intellectual Property. The Services, and any and all software, workflow
          processes, API, user interfaces, databases, designs, documentation, videos created by LoanBoss, and other
          technologies or content provided by LoanBoss as part of the Services (collectively, the &ldquo;LoanBoss
          Intellectual Property&rdquo;), are and shall remain the property of LoanBoss and, if applicable, its
          licensors, and all right, title and interest in and to the LoanBoss Intellectual Property, including all
          associated intellectual property rights, remain only with LoanBoss and, if applicable, its licensors, along
          with any know-how, inventions, methods or techniques related to the Services developed or conceived as a
          result of LoanBoss providing, or Client using, the Services, including without limitation any derivative
          works, improvements or enhancements and/or extensions of the foregoing (collectively, the
          &ldquo;Developments&rdquo;). Client hereby unconditionally and irrevocably assigns to LoanBoss any and all
          rights it might otherwise acquire in the LoanBoss Intellectual Property and any Developments as a result of
          its use of the Services or otherwise. Client may not make any modification to the Services, including
          removal or modification of any proprietary marking or restrictive legends contained therein. LoanBoss
          reserves all rights unless expressly granted in this Agreement.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          d. Aggregate Data. Client hereby agrees that LoanBoss and its successors and assigns
          may collect, use, publish, disseminate, sell, transfer, and otherwise exploit the Client Content provided
          that such Client Content has been aggregated, anonymized, and de-identified by LoanBoss (&ldquo;Aggregate
          Data&rdquo;). Aggregate Data does not and shall not identify Client, any User, or any individual. Aggregate
          Data may also be combined with Usage Data (as defined below), and such combined data, or subsets thereof,
          may be used by LoanBoss for any lawful purpose. &ldquo;Usage Data&rdquo; means data collected by LoanBoss in
          monitoring the performance and use of the Services by Client, and may include, without limitation, date and
          time that Users access the Services, the portions of the Services visited, the frequency and number of times
          the Services are accessed, and other performance data. LoanBoss is the sole owner of all right, title, and
          interest in and to the Aggregate Data and the Usage Data, which shall be deemed LoanBoss Intellectual
          Property for purposes of this Agreement.
        </span>
      </p>
      <h4 className="c5" id="h.oaye11u8tssv"><span className="c4">5. Representations and Warranties</span></h4>
      <p className="c2">
        <span className="c1">
          a. Mutual Representations and Warranties. Each party represents and warrants to the
          other party that: (i) it is duly organized, validly existing, and in good standing under its jurisdiction of
          organization and has the right to enter into this Agreement and Orders; (ii) the execution, delivery, and
          performance of this Agreement, and Orders and the consummation of the transactions contemplated hereby are
          within the corporate powers of such party and have been duly authorized by all necessary corporate action on
          the part of such party, and constitute a valid and binding agreement of such party; (iii) it has the full
          power, authority, and right to perform its obligations and grant the rights it grants hereunder; and (iv)
          its performance under this Agreement shall comply with all Applicable Laws.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. Client Representations and Warranties. Client represents and warrants to LoanBoss
          that it has all necessary rights, and has obtained all necessary consents, to upload the Client Content and
          use the Client Content in connection with the Services, and to grant the rights and licenses granted
          hereunder with respect to all Client Content. Client further represents and warrants to LoanBoss that the
          Client Content does not and will not infringe, violate, or misappropriate any right of any third party,
          including, without limitation, any intellectual property rights.
        </span>
      </p>
      <p className="c2">
        <span className="c3">c. DISCLAIMER. EXCEPT AS EXPRESSLY SET FORTH IN </span>
        <span className="c6 c3">
          SECTION
          5(a)
        </span>
        <span className="c1">
          , THE SERVICES, THE LOANBOASS WEBSITE, THEIR COMPONENTS, ANY DOCUMENTATION, AND
          ANY OTHER MATERIALS PROVIDED BY LOANBOSS HEREUNDER ARE PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS
          AVAILABLE,&rdquo; AND LOANBOSS MAKES NO REPRESENTATIONS OR WARRANTIES WITH RESPECT TO THE SAME OR OTHERWISE
          IN CONNECTION WITH THIS AGREEMENT OR ANY ORDER, AND HEREBY DISCLAIMS ANY AND ALL EXPRESS, IMPLIED, OR
          STATUTORY WARRANTIES, INCLUDING, WITHOUT LIMITATION, ANY WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, AVAILABILITY, ERROR-FREE OR UNINTERRUPTED OPERATION, AND ANY WARRANTIES
          ARISING FROM A COURSE OF DEALING, COURSE OF PERFORMANCE, OR USAGE OF TRADE. TO THE EXTENT THAT LOANBOSS MAY
          NOT, AS A MATTER OF APPLICABLE LAW, DISCLAIM ANY IMPLIED WARRANTY, THE SCOPE AND DURATION OF SUCH WARRANTY
          WILL BE THE MINIMUM PERMITTED UNDER SUCH LAW.
        </span>
      </p>
      <h4 className="c5" id="h.g119wxnskah4"><span className="c4">6. Mutual Confidentiality</span></h4>
      <p className="c2">
        <span className="c1">
          a. Definition of Confidential Information. &ldquo;Confidential Information&rdquo;
          means all non-public information disclosed by a party (&ldquo;Discloser&rdquo;) to the other party
          (&ldquo;Recipient&rdquo;), whether orally or in writing, that is designated as confidential or that
          reasonably should be understood to be confidential given the nature of the information and the circumstances
          of disclosure. LoanBoss&rsquo;s Confidential Information includes, without limitation, the Services
          (including, without limitation, the Services&rsquo; user interface design and layout and pricing
          information), the Aggregate Data, the Usage Data, the LoanBoss Intellectual Property, the Developments, and
          all non-public LoanBoss techniques, technology and processes. Client&rsquo;s Confidential Information shall
          include the Client Content.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. Protection of Confidential Information. The Recipient must use the same degree of
          care to protect the confidentiality of the Discloser&rsquo;s Confidential Information that it uses to
          protect the confidentiality of its own Confidential Information (but in no event less than reasonable care).
          The Recipient must not disclose or use any Confidential Information of the Discloser for any purpose outside
          the scope of this Agreement. The Recipient must make commercially reasonable efforts to limit access to
          Confidential Information of Discloser to those of its employees and contractors who need such access for
          purposes consistent with this Agreement and who are bound by confidentiality obligations to Recipient no
          less restrictive than the confidentiality terms of this Agreement. The Recipient shall be responsible for
          the acts and omissions of all of its employees and contractors, and any breach of this Agreement by any of
          its employees and contractors shall be deemed a breach of this Agreement by the Recipient.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          c. Exclusions. Notwithstanding subsection (a) of this Section, Confidential
          Information excludes information that: (i) is or becomes generally known to the public without breach of any
          obligation owed to Discloser; (ii) was known to the Recipient prior to its disclosure by the Discloser
          without breach of any obligation owed to the Discloser; (iii) is received from a third party without breach
          of any obligation owed to Discloser; or (iv) was independently developed by the Recipient without use or
          access to the Confidential Information. The Recipient may disclose Confidential Information to the extent
          required by law or court order, but will provide Discloser with advance notice to seek a protective order to
          the extent allowed by law or court order. If such protective order or other remedy is not obtained or the
          Discloser waives compliance with the provisions of this Section, the Recipient may furnish only that portion
          of the Discloser&rsquo;s Confidential Information which it is advised by its counsel is legally required to
          be disclosed and will use commercially reasonable efforts to ensure that confidential treatment will be
          afforded such disclosed portion of the Confidential Information.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          d. Return/Destruction of Confidential Information. Upon expiration or termination of
          the Agreement, the Recipient will, upon request of the Discloser, return to the Discloser, or destroy all
          copies of the Discloser&rsquo;s Confidential Information, except for archival and back-up copies on back-up
          tapes maintained to comply with Applicable Laws.
        </span>
      </p>
      <h4 className="c5" id="h.qtu9v29rdx6j"><span className="c4">7. Term and Termination</span></h4>
      <p className="c2">
        <span className="c1">
          a. Term. This Agreement continues until all Orders have terminated. The term of each
          Order (each, a &ldquo;Subscription Term&rdquo;) shall be set forth in the applicable Order.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          b. Termination. Either party may terminate this Agreement and/or any Order(s) if the
          other party (i) is in material breach of this Agreement and has not cured such breach within thirty (30)
          days of the date of notification by the non-breaching party; or (ii) becomes the subject of insolvency,
          receivership or bankruptcy proceedings (or such analogous proceedings applicable to a party under local
          laws) or any other proceedings for the settlement of either party&rsquo;s debts, or makes an assignment for
          the benefit of such party&rsquo;s creditors. In addition, LoanBoss may terminate an Order under the limited
          circumstances set forth in
          {" "}
        </span>
        <span className="c6 c3">Section 9(a)</span>
        <span
          className="c1"
        >
&nbsp;below.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          c. Return of Client Content. Within sixty (60) days after termination, upon request,
          LoanBoss will provide a flat file data export of Client Content. After such sixty (60) day period, LoanBoss
          has no obligation to maintain the Client Content and may destroy it. Notwithstanding the foregoing, LoanBoss
          reserves the right to retain an archival copy of the Client Content in accordance with
          {" "}
        </span>
        <span
          className="c6 c3 c9"
        >
          Section 4(a)
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          d. Return LoanBoss Property Upon Termination. Upon termination of this Agreement for
          any reason, Client must pay LoanBoss for any amounts due and owing to LoanBoss and destroy or return all
          property of LoanBoss, including, without limitation, the LoanBoss Confidential Information and Developments.
          Upon LoanBoss&rsquo;s request, Client will confirm in writing its compliance with this destruction or return
          requirement.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          e. Suspension of the Service. LoanBoss may temporarily suspend the Services or remove
          the applicable Client Content, or both, if it in good faith believes that (i) as part of using the Service,
          Client has violated a law or a restriction in
          {" "}
        </span>
        <span className="c6 c3">Section 2(c)</span>
        <span
          className="c1"
        >
          &nbsp;above, or (ii) any amount owed under an Order is more than thirty (30) days past due.
          LoanBoss will attempt to contact Client in advance of any suspension.
        </span>
      </p>
      <h4 className="c5" id="h.9a620iz653od"><span className="c4">8. Liability Limit</span></h4>
      <p className="c2">
        <span className="c1">
          a. EXCEPT FOR LIABILITY ARISING IN CONNECTION WITH A PARTY&rsquo;S GROSS NEGLIGENCE,
          WILLFUL MISCONDUCT, BREACH OF ITS CONFIDENTIALITY UNDER THIS AGREEMENT, OR INDEMNIFICATION OBLIGATIONS UNDER
          THIS AGREEMENT NEITHER PARTY SHALL BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, EXEMPLARY, PUNITIVE OR
          CONSEQUENTIAL DAMAGES ARISING OUT OF OR RELATED TO THIS AGREEMENT (INCLUDING, WITHOUT LIMITATION, COSTS OF
          DELAY, LOSS OF DATA, RECORDS OR INFORMATION, AND LOST PROFITS, REVENUE OR ANTICIPATED COST SAVINGS), EVEN IF
          IT KNOWS OF THE POSSIBILITY OF SUCH DAMAGE OR LOSS. LOANBOSS&rsquo;S TOTAL LIABILITY ARISING OUT OF OR
          RELATED TO THIS AGREEMENT (WHETHER IN CONTRACT, TORT OR OTHERWISE) WILL NOT EXCEED THE AMOUNT PAID OR
          PAYABLE BY CLIENT TO LOANBOSS WITHIN THE 12-MONTH PERIOD PRIOR TO THE EVENT THAT GAVE RISE TO THE
          LIABILITY.
        </span>
      </p>
      <p className="c2">
        <span className="c3">b. Exclusions. Notwithstanding the foregoing, nothing in </span>
        <span
          className="c6 c3"
        >
          Section 8
        </span>
        <span className="c1">
          &nbsp;shall limit or exclude either party&rsquo;s liability
          for any liability that cannot be limited or excluded by Applicable Law.
        </span>
      </p>
      <h4 className="c5" id="h.65ccf8um7prb"><span className="c4">9. Indemnity</span></h4>
      <p className="c2">
        <span className="c1">
          a. By LoanBoss. LoanBoss will indemnify, defend and hold Client harmless from and
          against any liabilities, costs, and expenses (including reasonable attorneys&rsquo; fees)
          (&ldquo;Losses&rdquo;) incurred by Client in connection with any third-party action, claim, or proceeding
          (each, a &ldquo;Claim&rdquo;) to the extent that such third-party Claim alleges that the Service or any
          LoanBoss technology used to provide the Service violates any US copyright, patent, trademark or other
          intellectual property right of a third party. If such a third-party Claim appears likely, then LoanBoss may,
          at its expense, (x) procure the necessary rights for Client to use the Service as provided in this Agreement
          and the applicable Order, (y) replace the infringing components of the Service or underlying technology with
          a substantially functional equivalent, or (z) suitably modify the Service or underlying technology so that
          it is non-infringing and functionally equivalent. If LoanBoss determines that none of these options are
          reasonably available, then LoanBoss may terminate the applicable Order and refund a pro-rata portion of any
          Fees prepaid by Client for Services not yet rendered. Notwithstanding anything to the contrary herein,
          LoanBoss has no obligation to indemnify, defend, or hold Client harmless in connection with any Claim
          arising from (i) Client&rsquo;s or any User&rsquo;s combination of the Service with other technology,
          services, software or hardware where the infringement would not have occurred but for the combination; (ii)
          any unauthorized modifications, alterations, or implementations of the Service made by or on behalf of
          Client (other than by LoanBoss); (iii) Client&rsquo;s or its Users&rsquo; use of the Service not in
          accordance with the documentation provided by LoanBoss, this Agreement, and/or an Order; or (iv)
          Client&rsquo;s or its Users&rsquo; use of the Service in a manner or for a purpose for which they were not
          designed. This section contains Client&rsquo;s exclusive remedies and LoanBoss&rsquo;s sole liability for
          intellectual property infringement Claims.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          b. By Client. Client will indemnify, defend, and hold LoanBoss, its affiliates, its
          suppliers and hosting providers, and its and their respective officers, directors, members, managers,
          partners, employees, contractors or agents (&ldquo;LoanBoss Indemnified Parties&rdquo;) harmless from and
          against any and all Losses incurred by any LoanBoss Indemnified Party in connection with any third-party
          Claim to the extent such Claim arises out of (i) any allegation that the Client Content or any portion
          thereof, or any use by LoanBoss thereof as permitted under this Agreement, infringes, misappropriates, or
          violates that any patent, copyright, trade secret, contract right or other right of any third party, (ii)
          Client&rsquo;s breach of any of the representations and warranties made under
          {" "}
        </span>
        <span
          className="c6 c3"
        >
          Section 5
        </span>
        <span className="c1">
          &nbsp;above, or (iii) Client&rsquo;s gross negligence or
          willful misconduct.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          c. Procedure. The indemnified party shall promptly notify the indemnifying party in
          writing of any third-party Claim for which the indemnifying party may have obligations under this
        </span>
        <span className="c3 c6">Section 9</span>
        <span className="c3">
          ; provided, however, that any failure of the
          indemnified party to provide prompt written notice pursuant to this
          {" "}
        </span>
        <span className="c6 c3">
          Section
          9
        </span>
        <span className="c1">
          &nbsp;shall excuse the indemnifying party only to the extent that it is prejudiced
          thereby. The indemnified party shall reasonably cooperate with the indemnifying party, at the indemnifying
          party&rsquo;s sole expense, with regard to the defense of any Claim. The indemnifying party shall have full
          control of any such Claim and the authority to settle or otherwise dispose of any suit or threatened suit.
          In no event, however, may the indemnifying party agree to any settlement of any Claim for which it has
          agreed to provide indemnification under this Agreement if such settlement would impose any liability or
          obligation upon the indemnified party, without the indemnified party&rsquo;s prior, written consent.
        </span>
      </p>
      <h4 className="c5" id="h.pxx5q5vrpozp"><span className="c4">10. Data Protection</span></h4>
      <p className="c2"><span className="c1">a. Definitions and Interpretation</span></p>
      <p className="c2">
        <span className="c1">
          I. &ldquo;Client Personal Data&rdquo; means any Personal Data in respect of which
          Client is a data controller or another entity&rsquo;s data processor that is processed by LoanBoss as a data
          processor or subprocessor, respectively, in connection with its performance of the Services.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          II. &ldquo;Personal Data&rdquo; means any data concerning individuals located in the
          European Economic Area (the &ldquo;EEA&rdquo;) falling within the definition of &ldquo;personal data&rdquo;
          under Directive 95/46/EC of the European Parliament and of the Council (the &ldquo;Directive&rdquo;) or any
          replacement legislation, as applicable, including the General Data Protection Regulation 2016/679 (the
          &ldquo;GDPR&rdquo;) and the Member State implementations of the GDPR (collectively, &ldquo;EU Data
          Protection Laws&rdquo;).
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          III. Terms defined in the EU Data Protection Laws including, but not limited to,
          &ldquo;controller&rdquo; and &ldquo;processor,&rdquo; shall have the same meaning when used, unless
          otherwise defined, herein.
        </span>
      </p>
      <p className="c2"><span className="c1">b. Nature of the Processing</span></p>
      <p className="c2">
        <span className="c1">
          I. Subject Matter. The subject matter of Personal Data processing by LoanBoss is the
          provision of the Services to the clients of LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          II. Duration. LoanBoss will process Personal Data during the Subscription Term and up
          to sixty (60) days after the expiration of the Subscription Term pursuant to
          {" "}
        </span>
        <span
          className="c6 c3"
        >
          Section 7(c)
        </span>
        <span className="c1">&nbsp;above.</span>
      </p>
      <p className="c2">
        <span className="c1">
          III. Nature and Purpose. Processing is done to provide the Services to Client and
          communicate with Client in relation to the Services.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          IV. Data Categories. LoanBoss shall process Personal Data entered into the Services
          by Client, as well as Personal Data provided by Client personnel interacting with LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          V. Data Subjects. Processing concerns Client&rsquo;s personnel using the Services or
          otherwise involved in their procurement or use by Client and third-party data subjects whose Personal Data
          is included in the Client Content.
        </span>
      </p>
      <p className="c2"><span className="c1">c. Processor Obligations</span></p>
      <p className="c2">
        <span className="c1">
          I. Client and LoanBoss acknowledge and agree that Client is the controller of Client
          Personal Data and LoanBoss is the processor of Client Personal Data pursuant to the Agreement. In certain
          instances, Client may be the processor of Client Personal Data, in which case LoanBoss is appointed as a
          subprocessor of such Client Personal Data pursuant to the Agreement. Whether LoanBoss is serving as a
          processor or subprocessor, LoanBoss&rsquo;s obligations shall remain pursuant to this Agreement, which align
          with LoanBoss&rsquo;s obligations as a processor pursuant to EU Data Protection Laws.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          II. LoanBoss shall only use, disclose, or otherwise process Client Personal Data
          (including transfers to third countries from the EEA), on behalf of and in accordance with Client&rsquo;s
          documented instructions, unless otherwise required under applicable law.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          III. Client hereby authorizes LoanBoss to transfer Client Personal Data to the United
          States for provision of the Services and performance under this Agreement, provided that (1) LoanBoss is
          self-certified to the E.U.-U.S. Privacy Shield with respect to Client Personal Data; or (2) LoanBoss and
          Client have entered into Commission Decision C(2010)593 Standard Contractual Clauses (Processors)
          (&ldquo;Model Clauses&rdquo;) with respect to Client Personal Data, as applicable.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          IV. LoanBoss shall ensure that its personnel authorized to process Client Personal
          Data are subject to a duty of confidentiality by contract or are under an appropriate statutory obligation
          of confidentiality with respect to Client Personal Data.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          V. LoanBoss shall implement appropriate technical and organizational measures with
          respect to the Client Personal Data, after taking into account the state of the art, the costs of
          implementation, and the nature, scope, context, and purposes of processing as well as the risk of varying
          likelihood and severity for the rights and freedoms of data subjects, for the purpose of ensuring a level of
          security appropriate to the risk.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          VI. Upon becoming aware of an accidental or unlawful destruction, loss, alteration,
          unauthorized disclosure, access, or use of Client Personal Data (each, a &ldquo;Security Incident&rdquo;),
          LoanBoss shall notify Client without undue delay. LoanBoss shall further assist Client in fulfilling its
          personal data breach notification obligations under the GDPR, taking into account the nature of the
          processing and the information available to the LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          VII. Client hereby consents to LoanBoss&rsquo;s use of the third parties described in
          the LoanBoss Subprocessor List in Appendix A at www.LoanBoss.com/terms, as such list may be updated from
          time to time (&ldquo;Downstream Subprocessors&rdquo;) to process Client Personal Data pursuant to the
          Agreement. Client may opt-in to receiving notifications regarding new Downstream Subprocessors during the
          term of the Agreement by written notice to
          {" "}
        </span>
        <span className="c11">Privacy@LoanBoss.com</span>
        <span
          className="c1"
        >
          . If Client reasonably objects in writing to a new or replacement Downstream Subprocessor within
          seven (7) calendar days after receipt of such notice, and the parties cannot resolve Client&rsquo;s
          reasonable objection within fourteen (14) calendar days after receipt of such objection, then Client may
          terminate the Services impacted by the new or replacement Downstream Subprocessor on written notice to
          LoanBoss without penalty and receive a pro-rata refund of any fees paid in advance.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          VIII. Notwithstanding the foregoing, LoanBoss may replace or add a Downstream
          Subprocessor without prior notice to Client if, in its sole discretion, such action is necessary to prevent
          or mitigate risk to the Services, Personal Data, technology infrastructure, or Clients. LoanBoss shall
          notify Client of the replacement or additional Downstream Subprocessor as soon as possible, and Client shall
          retain the right to object to such Downstream Subprocessor as described in (vii) above upon receipt of such
          notice.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          IX. LoanBoss shall enter into written contracts with its Downstream Subprocessors
          that include data protection obligations that are at least as strict as the standard set forth in this
          Agreement and shall remain liable for any breach by Downstream Subprocessor under this Agreement as if it
          were a breach by LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          X. Taking into account the nature of the processing, and to the extent Client cannot
          fulfill such obligations directly via the Services, LoanBoss shall provide commercially reasonable
          assistance, including through appropriate technical or organizational measures, insofar as this is possible,
          to Client to fulfill its obligations to respond to data subject rights requests, specifically the right to
          access, rectification, erasure, restriction, objection, or portability, as applicable under the GDPR. If
          LoanBoss receives a request directly from a data subject it will notify Client of the request (including all
          relevant details provided by data subject) and await Client&rsquo;s instructions.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          XI. LoanBoss shall notify Client without undue delay if a supervisory authority or
          law enforcement authority makes any inquiry or request for disclosure of Client Personal Data.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          XII. LoanBoss shall provide Client with reasonable assistance should Client conduct a
          data protection impact assessment regarding the Services, including providing information reasonably
          necessary for Client&rsquo;s prior consultation with a supervisory authority regarding such data protection
          impact assessment.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          XIII. LoanBoss shall make available to Client all information necessary to
          demonstrate compliance with the obligations laid down in this Agreement and, at Client&rsquo;s expense,
          allow for and contribute to audits, including inspections, conducted by the Client or an independent
          third-party auditor mandated by the Client. LoanBoss shall inform Client immediately if, in its opinion, a
          Client instruction infringes the GDPR or other EU or Member State data protection provision.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          XIV. Upon termination or expiration of this Agreement, LoanBoss shall, in accordance
          with the terms of this Agreement, delete or return to Client all relevant Client Personal Data (and delete
          all copies) in LoanBoss&rsquo;s possession, save to the extent that LoanBoss is required under any
          applicable law to retain some or all Client Personal Data. In such event, LoanBoss shall extend the
          protections of this Agreement to such Client Personal Data and limit processing of such Client Personal Data
          to only those purposes required by applicable law, for so long as LoanBoss maintains the Client Personal
          Data.
        </span>
      </p>
      <p className="c2"><span className="c1">d. General Provisions</span></p>
      <p className="c2">
        <span className="c1">
          I. Each party hereby represents and warrants to the other party that it complies, and
          will continue to comply, with applicable EU Data Protection Laws including, but not limited to,
          Client&rsquo;s and LoanBoss&rsquo;s obligations regarding Client Personal Data pursuant to this
          Agreement.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          II. Client hereby grants LoanBoss the right to process and use the Aggregated Data as
          described in
          {" "}
        </span>
        <span className="c6 c3">Section 4(d</span>
        <span className="c1">
          ), including, but not limited to,
          for the purposes of statistics, usage reporting, data analytics, industry analysis, market research, and
          other similar purposes, and for general business purposes including, but not limited to, the sale and/or
          license of Aggregated Data to third parties.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          III. The headings of any sections, subsections, and paragraphs of this Agreement are
          inserted for convenient reference only and are not intended to be part of or to affect the meaning or
          interpretation of this Agreement.
        </span>
      </p>
      <h4 className="c5" id="h.2q21x7ljqyb6"><span className="c4">11. LoanBoss Ongoing Services</span></h4>
      <p className="c2">
        <span className="c1">
          During any Subscription Term for which LoanBoss&rsquo;s is licensed, if applicable,
          LoanBoss will regularly update the following types of data within the Services on the terms and conditions
          contained herein:
        </span>
      </p>
      <ul className="c13 lst-kix_7x11m6xtu50a-0 start">
        <li className="c0 li-bullet-0"><span className="c1">&ndash; Net Operating Income (NOI)</span></li>
        <li className="c0 li-bullet-0"><span className="c1">&ndash; Occupancy</span></li>
        <li className="c0 li-bullet-0"><span className="c1">&ndash; Loan balance</span></li>
      </ul>
      <p className="c2">
        <span className="c1">
          Client shall designate an employee or third party that is responsible for providing
          updated data to LoanBoss. Client must notify LoanBoss of any change to Client&rsquo;s designated contact.
          LoanBoss will provide a process and instructions by which Client (or Client&rsquo;s designated contact) may
          provide updated data to LoanBoss. LoanBoss shall have no obligation to update data unless updates are
          submitted within the given update period and in accordance with LoanBoss&rsquo;s reasonable instructions.
          Client is solely responsible for the completeness and quality of data and/or images provided to LoanBoss.
          LoanBoss will accept the following file formats: .txt, .csv, .xls(x), .pdf, .jpeg, .png, .doc(x), and .rtf.
          LoanBoss does not accept file formats that are not designed to be human-readable (e.g., .xml, database
          extracts, etc.).
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          Client (or Client&rsquo;s designated contact) is responsible for working with the
          LoanBoss team to approve the mapping from Client&rsquo;s original source data to the appropriate LoanBoss
          data items. LoanBoss will have no responsibility for mapping issues discovered after Client has approved the
          mapping. Should the format of Client&rsquo;s data change for any reason, Client (or Client&rsquo;s
          designated contact) will be required to repeat the mapping process with the LoanBoss team (which may be
          subject to additional deployment fees).
        </span>
      </p>
      <p className="c2">
        <span className="c3">All data described in this </span>
        <span className="c6 c3">Section 11</span>
        <span
          className="c1"
        >
&nbsp;shall be deemed Client Content for purposes of this Agreement.
        </span>
      </p>
      <h4 className="c5" id="h.en73987njmpu"><span className="c4">12. Service Levels.</span></h4>
      <p className="c2">
        <span className="c1">
          LoanBoss shall use commercially reasonable efforts to maintain the online
          availability of the Services for a minimum of availability in any given month of 99.5% (excluding scheduled
          maintenance, force majeure and outages that result from any Client or third party technology issues).
          LoanBoss reserves the right to modify the Services from time to time by adding, deleting, or modifying
          features to improve the user experience or for other business purposes, and to modify the customer support
          provided in connection with the Services. LoanBoss further reserves the right to discontinue any feature of
          the Services at any time at LoanBoss&rsquo;s sole, reasonable discretion. Any such modification or
          discontinuance during any Subscription Term shall not materially decrease the overall functionality of the
          Services.
        </span>
      </p>
      <h4 className="c5" id="h.btph8cgat5z2"><span className="c4">13. Other Terms</span></h4>
      <p className="c2">
        <span className="c1">
          a. Entire Agreement and Changes. This Agreement and all executed Order(s) constitute
          the entire agreement between the parties and supersede any prior or contemporaneous negotiations or
          agreements, whether oral or written, related to this subject matter. Client is not relying on any
          representation concerning this subject matter, oral or written, not included in this Agreement. No
          representation, promise or inducement not included in this Agreement is binding.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          LoanBoss may update or revise this Agreement from time to time in its sole discretion
          without notice to Client, and LoanBoss recommends that Client review this Agreement on a regular basis to
          stay abreast of the most current version. The most current version will be posted on the LoanBoss site.
          Client&rsquo;s continued use of the Services after any update or revision to this Agreement constitutes
          Client&rsquo;s acceptance of the updates or revisions. No waiver of this Agreement is effective against a
          party unless that party signs such waiver in writing. Client shall appoint an account owner who shall have
          the authority to add subscriptions to Client&rsquo;s account by written request (including email),
          online/in-app request and other means which may be introduced by LoanBoss. Client shall be bound by all
          actions of its account owner. Client may change the account owner upon written notice to LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          b. No Assignment. Neither party may assign or transfer this Agreement (including by
          operation of law) or an Order to a third party, except that this Agreement with all Orders may be assigned
          by LoanBoss, without the consent of Client, as part of a merger, reorganization, change in control, or sale
          of substantially all the assets of LoanBoss.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          c. Independent Contractors. The parties are independent contractors with respect to
          each other and nothing in this Agreement shall be deemed to establish any partnership, joint venture,
          employment, franchise or agency relationship. Further, neither party will have the power to bind the other
          without the other&rsquo;s prior written consent nor make any representation that it has any such
          power.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          d. Force Majeure. Except for the payment of monies, neither party is liable for
          events beyond its reasonable control, including, without limitation, force majeure events.
        </span>
      </p>
      <p className="c2">
        <span className="c3">e. Money Damages Insufficient. Any breach by a party of </span>
        <span
          className="c6 c3"
        >
          Sections 4
        </span>
        <span className="c3">&nbsp;and </span>
        <span className="c6 c3">6</span>
        <span
          className="c1"
        >
          &nbsp;of this Agreement or violation of the other party&rsquo;s intellectual property rights will
          cause irreparable injury or harm to the other party. In such an event, the other party shall, without
          waiving any further remedies, be entitled to obtain a court order from a court of competent jurisdiction to
          stop any breach or avoid any future breach. Such party will not be required to post a bond or other security
          in connection with the granting of any such injunctive or equitable relief.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          f. No Additional Terms; No Waiver. LoanBoss rejects additional or conflicting terms
          of any Client form-purchasing document. No failure or delay by either Party in exercising any right or
          remedy under this Agreement will operate, or be deemed to operate, as a waiver of any such right or
          remedy.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          g. Order of Precedence. If there is an inconsistency between this Agreement and an
          Order, the Order prevails.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          h. Survival of Terms. Any terms that by their nature survive termination of this
          Agreement for a party to assert its rights and receive the protections of this Agreement will survive
          (including, without limitation, the confidentiality terms, the proprietary rights, the disclaimer, and the
          indemnity terms). The UN Convention on Contracts for the International Sale of Goods does not apply.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          i. Severability. If any provision (or part of a provision) of this Agreement is found
          by any court or administrative body of competent jurisdiction to be invalid, unenforceable or illegal, the
          other provisions shall remain in force.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          j. Feedback. By submitting ideas, suggestions or feedback to LoanBoss regarding the
          Service, Client agrees that such items submitted do not contain confidential or proprietary information, and
          Client hereby grants LoanBoss an irrevocable, unlimited, royalty-free and fully-paid perpetual license to
          use such items for any business purpose, without any compensation or attribution to Client.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          k. Reference Account. Client shall allow LoanBoss to use its name and logo in its
          marketing communications and materials, in accordance with Client&rsquo;s trademark guidelines and
          policies.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          l. Anti-Bribery. No payments or undue financial or other advantage of any kind shall
          be made by Client to advisers or agents, directly or indirectly, to any entity, government, corporation or
          other person for the purpose of improperly influencing the consideration of applications for a business
          activity or the receipt of any other benefits, including the obtaining or retaining of business. Each party
          shall:
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          I. comply with all Applicable Laws relating to anti-bribery and/or
          anti-corruption;
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          II. not engage in any activity, practice or conduct which constitutes an offense
          under any applicable anti-bribery and/or anti-corruption legislation; and
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          III. notify the other party immediately if it becomes aware that, or has reason to
          believe that, it has breached his obligations under this paragraph.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          m. No Third-Party Beneficiaries. Except as otherwise expressly provided for in this
          Agreement, nothing in this Agreement, express or implied, is intended or shall be construed to create any
          rights in, or confer any benefits upon, any person or entity other than the parties to this Agreement. No
          person who is not a party to this Agreement shall have any right to enforce any term of this
          Agreement.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          n. Governing Law and Venue. This Agreement is governed by the laws of the State of
          North Carolina (without regard to conflicts of law principles) for any dispute between the parties arising
          out of or relating to the subject matter of this Agreement. The parties irrevocably submit to the exclusive
          jurisdiction of the state and federal courts in Charlotte, North Carolina for any dispute between the
          parties arising out of or relating to the subject matter of this Agreement.
        </span>
      </p>
      <p className="c2">
        <span className="c3">
          Where Client is a resident of the EEA, any dispute between the parties arising out of
          or in connection with this Agreement, including any question regarding its existence, validity or
          termination, shall be referred to and finally resolved by arbitration under the rules of the London Court of
          International Arbitration, which are deemed to be incorporated by reference into this
          {" "}
        </span>
        <span
          className="c6 c3"
        >
          Section 13
        </span>
        <span className="c1">
          . The number of arbitrators shall be one. The seat, or legal
          place, of arbitration shall be in London. The language to be used in the arbitral proceedings shall be
          English. Throughout this arbitration, the governing law of the contract shall be in the substantive law of
          the State of North Carolina.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          o. Digital Millennium Copyright Act. LoanBoss respects the intellectual property
          rights of others and attempts to comply with all relevant laws. In accordance with the Digital Millennium
          Copyright Act of 1998, the text of which may be found on the U.S. Copyright Office website at
          http://www.copyright.gov/legislation/dmca.pdf, LoanBoss will respond expeditiously to claims of copyright
          infringement committed using the Website that are reported to LoanBoss&rsquo; Designated Copyright Agent.
          LoanBoss will review all claims of copyright infringement received and remove any content deemed to have
          been posted or distributed in violation of any such laws.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          Our designated agent under the Digital Millennium Copyright Act (the
          &ldquo;Act&rdquo;) for the receipt of any Notification of Claimed Infringement which may be given under that
          Act is as follows:
        </span>
      </p>
      <p className="c2"><span className="c1">Copyright Agent</span></p>
      <p className="c2"><span className="c1">c/o LoanBoss, Inc.</span></p>
      <p className="c2"><span className="c1">1300 South Mint Street, #410</span></p>
      <p className="c2"><span className="c1">Charlotte, NC 28203</span></p>
      <p className="c2"><span className="c1">support@loanboss.com</span></p>
      <p className="c2">
        <span className="c1">
          If you believe that your work has been copied on the LoanBoss platform or website in
          a way that constitutes copyright infringement, please provide our agent with notice in accordance with the
          requirements of the Act, including (i) a description of the copyrighted work that has been infringed and the
          specific location on the Website where such work is located; (ii) a description of the location of the
          original or an authorized copy of the copyrighted work; (iii) identify the material that you claim is
          infringing (or to be the subject of infringing activity) and that you contend is to be removed or access to
          which is to be disabled, and information reasonably sufficient to permit us to locate the material,
          including at a minimum, if applicable, the URL of the link shown on the Site(s) where such material may be
          found, (iv) your address, telephone number and, if available, e-mail address; (v) a statement by you that
          you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent or
          the law (e.g. as a fair use); (vi) a statement by you, made under penalty of perjury, that the information
          in your notice is accurate and that you are the copyright owner or authorized to act on the copyright
          owner&rsquo;s behalf; and (vii) an electronic or physical signature of the owner of the copyright or the
          person authorized to act on behalf of the owner of the copyright interest.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          p. Trademarks and Service Marks. Any and all trademarks, service marks, and logos of
          LoanBoss (the &ldquo;LoanBoss Trademarks&rdquo;) used and displayed on the LoanBoss website are registered
          and unregistered trademarks or service marks of LoanBoss. Other company, product, and service names located
          on the LoanBoss website may be trademarks or service marks owned by others (the &ldquo;Third-Party
          Trademarks,&rdquo; and, collectively with LoanBoss Trademarks, the &ldquo;Trademarks&rdquo;). Nothing on the
          LoanBoss website should be construed as granting, by implication, estoppel, or otherwise, any license or
          right to use the Trademarks, without LoanBoss&rsquo; prior written permission specific for each such use.
          Use of the Trademarks as part of a link to or from any site is prohibited unless establishment of such a
          link is approved in advance by LoanBoss in writing. All goodwill generated from the use of LoanBoss
          Trademarks inures to the benefit of LoanBoss. Elements of the LoanBoss website are protected by trade dress,
          trademark, unfair competition, and other state and federal laws and may not be copied or imitated in whole
          or in part, by any means, including, but not limited to, the use of framing or mirrors. None of the Services
          or Content may be retransmitted without the express, written consent of LoanBoss for each and every
          instance.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          q. Additional Notice to Non-U.S. Residents. The LoanBoss website and the affiliated
          servers are based in the United States. LoanBoss makes no claims concerning whether the Services may be
          accessed, viewed, or be appropriate for use outside of the United States. If Client accesses the LoanBoss
          website or the Services from outside of the United States, Client does so at Client&rsquo;s own risk.
          Whether inside or outside of the United States, Client is solely responsible for ensuring compliance with
          the laws of Client&rsquo;s specific jurisdiction.
        </span>
      </p>
      <p className="c2"><span className="c1">Please Note: You are entering into a legally binding agreement.</span></p>
      <p className="c2"><span className="c1">Last updated on July 27, 2020</span></p>
      <p className="c2"><span className="c1">LoanBoss Platform Subprocessors</span></p>
      <p className="c2">
        <span className="c1">
          Amazon Web Services: Physical Hosting Environment. The Production instance is located
          in AWS region us-east-1, N. Virginia.
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          Nagios: URL and end point monitoring to make sure the application is up and
          responding
        </span>
      </p>
      <p className="c2">
        <span className="c1">
          Sisense: Business intelligence platform that allows users to join, analyze, and
          picture out information to give insight into business metrics.
        </span>
      </p>
      <p className="c7"><span className="c9 c12 c14" /></p>

    </PageWrapper>
  );
}

